import styled from "styled-components";

import { theme } from "../../themes/themes";
export const FormCard = styled.div`
  left: 25%;
  bottom: 10%;
  width: 600px;
  height: fit-content;
  max-width: 70%;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.primaryLight};
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  background: ${({ theme }) => theme.neutral.white};
  box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primaryLight};
  overflow: auto;
  @media only screen and (min-width: 769px) {
    left: 25%;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    left: 15%;
  }
  @media only screen and (max-width: 480px) {
    left: 15%;
  }
  .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label {
    font-size: 13px;
  }
`;

export const TextTitleList = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-size: 18px;
`;

export const Hr = styled.hr`
  width: 98%;
  margin-bottom: 1rem;
`;

export const ContentSelect = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  grid-gap: 0.2em;
  padding: 0px 11px;
  ${(props) => (props.OnlyAssigned ? `z-index:3;` : ``)}
  ${(props) => (props.OnlyAssigned ? `background: white;` : ``)}
  border-radius: 9px;

  input {
    width: 100%;
    height: 30px;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }

  .css-1hb7zxy-IndicatorsContainer {
    div:nth-child(1) {
      display: ${(props) => (props.users ? "none" : "")};
    }
  }
  .css-xb97g8 {
    display: ${(props) => (props.users ? "none" : "")};
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
    };
  },
};

export const IconGuest = styled.img`
  width: 18.33px;
`;

export const CounterTotalUsers = styled.span`
  font-size: 36px;
`;

export const SectionWrapper = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  grid-gap: 0.2em;
  font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};

  input {
    padding: 0.5em;
    width: 100%;
    height: 40px;
    border: 1px solid ${({ theme }) => theme.secondaryGrayLightOne};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input:focus {
    border-color: ${({ theme }) => theme.secondaryPinkLightOne};
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.secondaryPinkLightOne};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }

  label {
    font-weight: 400;
    font-size: 12px;
  }
`;

export const ButtonCancel = styled.button`
  border: 1px solid ${({ theme }) => theme.primary.purple};
  color: ${({ theme }) => theme.button.primary};
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  margin: 0px auto;
  font-size: 14px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonCreateGroup = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  margin: 0px auto;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
